module.exports = __webpack_public_path__ + "static/RB14-08ccc64d343f9e2594874138df5c1a44.mp4";